import React, {Component} from 'react'

import PaperBlock from "../../../ui/PaperBlock"

import Button from '@material-ui/core/Button'

/**
 * title
 * 
 * # onSaveClick
 * # onCancelClick
 * onCloseClick
 */

class ButtonPanel extends Component {

    render() {
        return <PaperBlock style = {{display: "flex", justifyContent: "right"}}>

            {/* <Button
				onClick = {e => {
					e.stopPropagation()
					if (typeof this.props.onSaveClick === "function") {
						this.props.onSaveClick()
					}
				}}
			>Сохранить</Button>*/}

            {/* <Button
				onClick = {e => {
					e.stopPropagation()
					if (typeof this.props.onCancelClick === "function") {
						this.props.onCancelClick()
					}
				}}
			>Отмена</Button>*/}

            <Button
				onClick = {e => {
					e.stopPropagation()
					if (typeof this.props.onCloseClick === "function") {
						this.props.onCloseClick()
					}
				}}
			>Закрыть</Button>

        </PaperBlock>
    }

}

export default ButtonPanel